module.exports = __webpack_public_path__ + "images/emoji/fr.d082222c6d9e7b819686.png";